<template>
  <div class="content-wrappper" @contextmenu="handler($event)">
    <div v-if="regIntelMetaData.length" class="col-sm-12 col-md-12 margin_top_15 margin_bottom_15">
      <p class="search_title">
        <span class="search_title">Select Report Criteria.</span>
      </p>
    </div>
    <div class="col-sm-12 col-md-12 margin_bottom_15">
      <div class="col-sm-3 col-md-3 col-xs-12 padding_rt10_lft0">
        <div class="search-container height_40">
          <div class="search-input">
            <multiselect
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              class="multiselect-single-dropdown"
              :searchable="true"
              :options="regIntelMetaData.map((country) => country.country_name)"
              v-model="country"
              @input="changeCountry"
              placeholder="Select Country"
            >
              <span slot="noResult">No matching data</span>
            </multiselect>
          </div>
        </div>
      </div>
      <div class="col-sm-3 col-md-3 col-xs-12 padding_rt10_lft0">
        <div class="search-container height_40">
          <div class="search-input">
            <multiselect
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              class="multiselect-single-dropdown"
              :class="!selectedDevice ? 'un-selected' : ''"
              :searchable="true"
              :options="deviceTypes.map((deviceType) => deviceType.artifact_id)"
              :custom-label="getArtifactNameById"
              v-model="selectedDevice"
              @input="changeDeviceType"
              placeholder="Select type"
            >
              <span slot="noResult">No matching data</span>
            </multiselect>
          </div>
          <div style="color: red">
            <span>*</span>
          </div>
        </div>
      </div>
      <div class="col-sm-4 col-md-4 col-xs-12 padding_rt10_lft0">
        <div class="search-container height_40">
          <div class="search-input">
            <multiselect
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              class="multiselect-single-dropdown"
              :class="!selectedClass ? 'un-selected' : ''"
              :searchable="true"
              :options="classTypes.map((classType) => classType.class_cntry_id)"
              :custom-label="getClassTypeNameById"
              v-model="selectedClass"
              @input="classValueSelected"
              placeholder="Select class"
            >
              <span slot="noResult">No matching data</span>
            </multiselect>
          </div>
          <div style="color: red">
            <span>*</span>
          </div>
        </div>
      </div>
      <div class="col-sm-2 col-md-2 col-xs-12 padding_rt10_lft0">
        <div class="search-container height_40">
          <div class="search-input">
            <button
              id="footerNext"
              class="btn emergo-green-button btn-block"
              name="ShowPathwayTabs"
              data-toggle="tab"
              @click="populateTabs"
              :disabled="srchPathwayDisabled"
            >
              View Report
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-11 col-md-11 margin_top_15">
      <DynaTabs
        :roleId="roleId"
        :userId="userId"
        :content="tabData"
        :noOfTabs="tabData.length"
        :country="country"
        @reloadMetaData="pullRegIntelData"
        @changeLoaderStatus="onChangeLoaderStatus"
      ></DynaTabs>
    </div>
    <div class="col-sm-11 col-md-11 margin_top_15 margin_bottom_15 disclaimer">
      Disclaimer: Reports are general in nature, not individualized to any particular product or
      manufacturer, and do not constitute a definitive or comprehensive statement of regulatory
      information. Emergo by UL is separately available to provide consulting services with respect
      to the regulatory processes applicable to particular products in specific markets.
    </div>
    <span>
      <loader :loadingStatus="loaderStatus"></loader>
    </span>
  </div>
</template>
<script>
import DynaTabs from './RegIntelTabs.vue';
import Loader from '../UIComponents/Loader.vue';
import { getRegIntelMetaData } from '../../apis/regulatoryIntelligence';

let countryArrLen = 0;
const DOC_SERVER_BASE_URL = `${process.env.VUE_APP_AZURE_BLOB_URL}/reports/regintel/`;

export default {
  props: ['account_id', 'roleId', 'userId'],
  data() {
    return {
      country: '',
      selectedDevice: '',
      tabData: [],
      srchPathwayDisabled: true,
      selected_countryObject: null,
      classIds: [],
      selectedClass: '',
      loaderStatus: false,
      deviceTypes: [],
      classTypes: [],
      defaultTabs: '',
      added_countries: {},
      regintelDefCntryRouted: {},
      regintelDefCntry: {},
      regIntelMetaData: []
    };
  },
  components: {
    DynaTabs,
    Loader
  },
  created() {
    if (this.$route.query.country) {
      this.pullRegIntelData(this.$route.query.country);
      if (this.regIntelMetaData.length) {
        this.initializeDefaultTabs(this.$route.query.country);
      }
    } else if (this.$route.params.filterCountry) {
      this.pullRegIntelData(this.$route.params.filterCountry);
      if (this.regIntelMetaData.length) {
        this.initializeDefaultTabs(this.$route.params.filterCountry);
      }
    } else {
      this.pullRegIntelData();
      if (this.regIntelMetaData.length) {
        this.initializeDefaultTabs();
      }
    }
  },
  mounted() {
    if (this.$route.query.country) {
      let defaultTabData;
      for (let i = 0; i < this.regIntelMetaData.length; i += 1) {
        if (this.regIntelMetaData[i].country_name === 'European Union') {
          defaultTabData = this.regIntelMetaData[i];
          break;
        }
      }
      this.regintelDefCntryRouted = defaultTabData;
      this.initializeDefaultTabs();
      this.populateTabs();
      this.selectedClass = 'C11';
      this.country = 'European Union';
      this.selectedDevide = '';
      this.srchPathwayDisabled = false;
      this.classValueSelected();
    }
  },

  watch: {
    regIntelMetaData() {
      if (this.regIntelMetaData.length && this.selectedClass === '') {
        this.initializeDefaultTabs();
      }
      const { selectedClass } = this;
      const { selectedDevice } = this;
      this.getCountriesWithMetaData();
      this.changeCountry();
      this.selectedDevice = selectedDevice;
      this.changeDeviceType();
      this.selectedClass = selectedClass;
      this.populateTabs();
    }
  },
  methods: {
    /**
     * initializeDefaultTabs()
     * Initializes the tabs for default pdf's
     */
    initializeDefaultTabs() {
      this.country = this.regintelDefCntry.country_name;
      this.deviceTypes = this.regintelDefCntry.med_artifact_types;
      countryArrLen = this.regIntelMetaData.length;
      this.selectedDevice = this.regintelDefCntry.med_artifact_types[0].artifact_id;
      this.classTypes = this.regintelDefCntry.med_artifact_types[0].classes;
      this.defaultTabs = this.regintelDefCntry.med_artifact_types[0].default_tabs;
      this.selectedClass = this.classTypes[0].class_cntry_id;

      this.tabData[0] = {
        title: this.defaultTabs[0].class_name,
        id: 1,
        content: this.defaultTabs[0].file_name
          ? `${DOC_SERVER_BASE_URL + this.country}/${this.defaultTabs[0].file_name}`
          : '',
        class_cntry_id: this.defaultTabs[0].class_cntry_id
      };
      this.tabData[1] = {
        title: this.classTypes[0].class_name,
        id: 2,
        content: this.classTypes[0].file_name
          ? `${DOC_SERVER_BASE_URL + this.country}/${this.classTypes[0].file_name}`
          : '',
        class_cntry_id: this.classTypes[0].class_cntry_id
      };
      this.tabData[2] = {
        title: this.defaultTabs[1].class_name,
        id: 3,
        content: this.defaultTabs[1].file_name
          ? `${DOC_SERVER_BASE_URL + this.country}/${this.defaultTabs[1].file_name}`
          : '',
        class_cntry_id: this.defaultTabs[1].class_cntry_id
      };
      this.getCountriesWithMetaData();
    },
    classValueSelected() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Dropdown Selected',
        dropdownValue: this.selectedClass,
        dropdownName: 'Class Dropdown'
      });
      this.srchPathwayDisabled = false;
    },
    /**
     * getMedicalArtifactsForCountry()
     * Returns medical artifacts for the specific country
     */
    getMedicalArtifactsForCountry(country, countryArray) {
      let loopVar = 0;
      let medArtifactsArr = {};
      while (loopVar < countryArray.length) {
        if (this.regIntelMetaData[loopVar].country_name === country) {
          medArtifactsArr = this.regIntelMetaData[loopVar].med_artifact_types;
          break;
        }
        loopVar += 1;
      }
      return medArtifactsArr;
    },
    /**
     * changeCountry()
     * Reloads the medical device data when country is changed
     */
    changeCountry() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Dropdown Selected',
        dropdownValue: this.country,
        dropdownName: 'Country Dropdown'
      });
      if (this.srchPathwayDisabled === false) {
        this.classTypes = [];
        this.selectedClass = '';
      }
      let loopVar = 0;
      while (loopVar < countryArrLen) {
        if (this.regIntelMetaData[loopVar].country_name === this.country) {
          this.deviceTypes = this.regIntelMetaData[loopVar].med_artifact_types;
          this.selected_countryObject = this.regIntelMetaData[loopVar];
          break;
        }
        loopVar += 1;
      }
      this.srchPathwayDisabled = true;
      if (this.selectedDevice && this.selectedDevice.length > 0) {
        this.selectedDevice = '';
      }
      if (this.classTypes && this.classTypes.length > 0) {
        this.classTypes = [];
        this.selectedClass = '';
      }
    },
    /**
     * changeDeviceType()
     * Reloads the classes when device type is changed
     */
    changeDeviceType() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Dropdown Selected',
        dropdownValue: this.selectedDevice,
        dropdownName: 'Device Type Dropdown'
      });
      this.selectedClass = '';
      let loopVar = 0;
      while (loopVar < this.deviceTypes.length) {
        if (this.deviceTypes[loopVar].artifact_id === this.selectedDevice) {
          this.classTypes = this.deviceTypes[loopVar].classes;
          this.defaultTabs = this.deviceTypes[loopVar].default_tabs;
          break;
        }
        loopVar += 1;
      }

      if (this.selectedClass && this.selectedClass.length > 0) {
        this.selectedClass = '';
      }
      this.srchPathwayDisabled = true;
    },
    /**
     * prepareTabData()
     * Returns array of tab data
     */
    prepareTabData() {
      // Read class array data here in a forEach loop.
      const tabDataArray = [];
      // Add an element for Overview
      tabDataArray[0] = {
        title: this.defaultTabs[0].class_name,
        id: 1,
        content: this.defaultTabs[0].file_name
          ? `${DOC_SERVER_BASE_URL + this.country}/${this.defaultTabs[0].file_name}`
          : '',
        class_cntry_id: this.defaultTabs[0].class_cntry_id
      };
      if (this.classIds && this.classIds.length > 0) {
        tabDataArray[this.classIds.length + 1] = {
          title: this.defaultTabs[1].class_name,
          id: this.classIds.length + 2,
          content: this.defaultTabs[1].file_name
            ? `${DOC_SERVER_BASE_URL + this.country}/${this.defaultTabs[1].file_name}`
            : '',
          class_cntry_id: this.defaultTabs[1].class_cntry_id
        };
      } else {
        tabDataArray[1] = {
          title: this.defaultTabs[1].class_name,
          id: 2,
          content: this.defaultTabs[1].file_name
            ? `${DOC_SERVER_BASE_URL + this.country}/${this.defaultTabs[1].file_name}`
            : '',
          class_cntry_id: this.defaultTabs[1].class_cntry_id
        };
      }
      if (this.classIds) {
        for (let j = 0; j < this.classIds.length; j += 1) {
          const tabElement = {
            title: this.classIds[j].class_id,
            id: j + 2,
            content: this.classIds[j].file_name
              ? `${DOC_SERVER_BASE_URL + this.country}/${this.classIds[j].file_name}`
              : '',
            class_cntry_id: this.classIds[j].class_cntry_id
          };
          tabDataArray[j + 1] = tabElement;
        }
      }
      return tabDataArray;
    },
    /**
     * populateTabs()
     * Populates tabs according to the classes
     */
    populateTabs() {
      this.loaderStatus = true;
      this.classIds = [];
      this.classIds[0] = this.extractClassObjects(this.classTypes);
      this.tabData = this.prepareTabData();
      this.loaderStatus = false;
    },
    // Fetches single class object based on classId
    extractClassObjects(classTypeArray) {
      for (let i = 0; i < classTypeArray.length; i += 1) {
        if (classTypeArray[i].class_cntry_id === this.selectedClass) {
          return this.classTypes[i];
        }
      }
      return null;
    },
    handler(e) {
      e.preventDefault();
    },
    /**
     * getCountriesWithMetaData()
     * Gets all the countries with meta data
     */
    getCountriesWithMetaData() {
      for (let index = 0; index < this.regIntelMetaData.length; index += 1) {
        this.added_countries[index] = {
          country_id: this.regIntelMetaData[index].country_id,
          country_name: this.regIntelMetaData[index].country_name
        };
      }
    },
    onChangeLoaderStatus(flag) {
      this.loaderStatus = flag;
    },
    // load reginteldata
    async pullRegIntelData(routedRegIntelDefCountry) {
      const responseData = await getRegIntelMetaData();
      this.regIntelMetaData = responseData.sort((a, b) =>
        a.country_name > b.country_name ? 1 : -1
      );
      if (routedRegIntelDefCountry) {
        for (let i = 0; i < this.regIntelMetaData.length; i += 1) {
          if (this.regIntelMetaData[i].country_name === routedRegIntelDefCountry) {
            this.regintelDefCntry = this.regIntelMetaData[i];
            break;
          }
        }
      } else {
        for (let i = 0; i < this.regIntelMetaData.length; i += 1) {
          if (this.regIntelMetaData[i].default_country === true) {
            this.regintelDefCntry = this.regIntelMetaData[i];
            break;
          }
        }
      }
      if (this.regintelDefCntry === null) {
        [this.regintelDefCntry] = this.regIntelMetaData;
      }
    },
    getArtifactNameById(id) {
      const device = this.deviceTypes.find((x) => x.artifact_id === id);
      return device ? device.artifact_name : undefined;
    },
    getClassTypeNameById(id) {
      const classType = this.classTypes.find((x) => x.class_cntry_id === id);
      return classType ? classType.class_name : undefined;
    }
  }
};
</script>
<style scoped>
.admin_Interface {
  padding: 8px 15px;
  border-radius: 20px;
  background: #55974b;
  font-weight: 300;
}
.search_title {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
}
.margin_bottom_15 {
  margin-bottom: 15px;
}

.margin_top_15 {
  margin-top: 15px;
}

.height_40 {
  height: 40px;
}
.search-input {
  position: relative;
  width: 95%;
  float: left;
}
.padding_rt10_lft0 {
  padding-right: 10px;
  padding-left: 0px;
}
.padding_rt0_lft10 {
  padding-right: 0px;
  padding-left: 10px;
}
.padding_lft10 {
  padding-left: 10px;
}
.padding_zero {
  padding-left: 10px;
}
.disclaimer {
  text-align: justify;
  font-size: 9pt;
  font-family: 'Calibri', sans-serif;
}
</style>
